import  {KeyWordSearchService}  from "./KeyWordSearchService";

/// <summary>
/// 关键字搜索纯POI（不搜公交线）
/// </summary>
export class PurePOIkeyWordSearchService extends KeyWordSearchService {

	constructor() {
		super();

	}


}//end PurePOIkeyWordSearchService

